import { actions } from "./action-list";

export function breakDownCollectionSummaryFetched(value) {
  return {
    type: actions.FETCH_BREAK_DOWN_COLLECTION.FETCH_BREAK_DOWN_COLLECTION_SUMMARY,
    value,
  };
}

export function navigationDataFetched(value) {
  return {
    type: actions.FETCH_BREAK_DOWN_COLLECTION.NAV_DATA,
    value,
  };
}

export function dayWiseBreakDownCollectionFetched(value) {
  return {
    type: actions.FETCH_BREAK_DOWN_COLLECTION.FETCH_DAY_WISE_BREAK_DOWN_COLLECTION,
    value,
  };
}

export function dayWiseBreakDownViewFetched(value) {
  return {
    type: actions.FETCH_BREAK_DOWN_COLLECTION.BREAK_DOWN_VIEW,
    value,
  };
}
